var map = {
	"./abkhazia.svg": 36881,
	"./afghanistan.svg": 81064,
	"./aland-islands.svg": 42085,
	"./albania.svg": 95406,
	"./algeria.svg": 74035,
	"./american-samoa.svg": 85574,
	"./andorra.svg": 69041,
	"./angola.svg": 46796,
	"./anguilla.svg": 58297,
	"./antigua-and-barbuda.svg": 60381,
	"./argentina.svg": 75933,
	"./armenia.svg": 96459,
	"./aruba.svg": 5659,
	"./australia.svg": 39004,
	"./austria.svg": 83975,
	"./azerbaijan.svg": 73689,
	"./azores-islands.svg": 26273,
	"./bahamas.svg": 88209,
	"./bahrain.svg": 14613,
	"./balearic-islands.svg": 86176,
	"./bangladesh.svg": 53373,
	"./barbados.svg": 71096,
	"./basque-country.svg": 41982,
	"./belarus.svg": 76402,
	"./belgium.svg": 79673,
	"./belize.svg": 46235,
	"./benin.svg": 88544,
	"./bermuda.svg": 63206,
	"./bhutan-1.svg": 4183,
	"./bhutan.svg": 57566,
	"./bolivia.svg": 51602,
	"./bonaire.svg": 69630,
	"./bosnia-and-herzegovina.svg": 44233,
	"./botswana.svg": 3991,
	"./brazil.svg": 75712,
	"./british-columbia.svg": 11564,
	"./british-indian-ocean-territory.svg": 99233,
	"./british-virgin-islands.svg": 49782,
	"./brunei.svg": 22025,
	"./bulgaria.svg": 76065,
	"./burkina-faso.svg": 36570,
	"./burundi.svg": 93077,
	"./cambodia.svg": 74416,
	"./cameroon.svg": 9654,
	"./canada.svg": 77604,
	"./canary-islands.svg": 12883,
	"./cape-verde.svg": 51318,
	"./cayman-islands.svg": 40952,
	"./central-african-republic.svg": 50391,
	"./ceuta.svg": 68482,
	"./chad.svg": 64252,
	"./chile.svg": 50377,
	"./china.svg": 66083,
	"./christmas-island.svg": 89132,
	"./cocos-island.svg": 97897,
	"./colombia.svg": 13436,
	"./comoros.svg": 10420,
	"./cook-islands.svg": 95915,
	"./corsica.svg": 71214,
	"./costa-rica.svg": 67176,
	"./croatia.svg": 58921,
	"./cuba.svg": 13809,
	"./curacao.svg": 35348,
	"./cyprus.svg": 8460,
	"./czech-republic.svg": 17224,
	"./democratic-republic-of-congo.svg": 67743,
	"./denmark.svg": 77860,
	"./djibouti.svg": 92420,
	"./dominica.svg": 87152,
	"./dominican-republic.svg": 66507,
	"./east-timor.svg": 44851,
	"./ecuador.svg": 18351,
	"./egypt.svg": 86291,
	"./england.svg": 59961,
	"./equatorial-guinea.svg": 52397,
	"./eritrea.svg": 71688,
	"./estonia.svg": 81439,
	"./ethiopia.svg": 99571,
	"./european-union.svg": 23755,
	"./falkland-islands.svg": 80448,
	"./faroe-islands.svg": 66416,
	"./fiji.svg": 74590,
	"./finland.svg": 43722,
	"./france.svg": 49015,
	"./french-polynesia.svg": 31111,
	"./french-southern-territories.svg": 12590,
	"./gabon.svg": 40123,
	"./galapagos-islands.svg": 80118,
	"./gambia.svg": 4173,
	"./georgia.svg": 29302,
	"./germany.svg": 94537,
	"./ghana.svg": 95679,
	"./gibraltar.svg": 58942,
	"./greece.svg": 75723,
	"./greenland.svg": 3180,
	"./grenada.svg": 45988,
	"./guam.svg": 38672,
	"./guatemala.svg": 4241,
	"./guernsey.svg": 85732,
	"./guinea-bissau.svg": 26622,
	"./guinea.svg": 68501,
	"./guyana.svg": 28143,
	"./haiti.svg": 66849,
	"./hawaii.svg": 69453,
	"./honduras.svg": 46362,
	"./hong-kong.svg": 99306,
	"./hungary.svg": 18732,
	"./iceland.svg": 3736,
	"./india.svg": 63375,
	"./indonesia.svg": 55148,
	"./iran.svg": 99358,
	"./iraq.svg": 86057,
	"./ireland.svg": 50635,
	"./isle-of-man.svg": 82124,
	"./israel.svg": 61034,
	"./italy.svg": 8907,
	"./ivory-coast.svg": 14004,
	"./jamaica.svg": 40136,
	"./japan.svg": 96710,
	"./jersey.svg": 90714,
	"./jordan.svg": 81272,
	"./kazakhstan.svg": 45544,
	"./kenya.svg": 28310,
	"./kiribati.svg": 85307,
	"./kosovo.svg": 88215,
	"./kuwait.svg": 89245,
	"./kyrgyzstan.svg": 16598,
	"./laos.svg": 6617,
	"./latvia.svg": 21967,
	"./lebanon.svg": 30133,
	"./lesotho.svg": 79212,
	"./liberia.svg": 78664,
	"./libya.svg": 69945,
	"./liechtenstein.svg": 60921,
	"./lithuania.svg": 65763,
	"./luxembourg.svg": 53978,
	"./macao.svg": 62291,
	"./macedonia.svg": 94493,
	"./madagascar.svg": 33662,
	"./madeira.svg": 83521,
	"./malawi.svg": 57957,
	"./malaysia.svg": 74915,
	"./maldives.svg": 42161,
	"./mali.svg": 17601,
	"./malta.svg": 43117,
	"./marshall-island.svg": 59258,
	"./martinique.svg": 58883,
	"./mauritania.svg": 72449,
	"./mauritius.svg": 37155,
	"./melilla.svg": 550,
	"./mexico.svg": 62735,
	"./micronesia.svg": 27350,
	"./moldova.svg": 24182,
	"./monaco.svg": 78719,
	"./mongolia.svg": 44060,
	"./montenegro.svg": 29908,
	"./montserrat.svg": 61187,
	"./morocco.svg": 61144,
	"./mozambique.svg": 18072,
	"./myanmar.svg": 95835,
	"./namibia.svg": 85701,
	"./nato.svg": 19814,
	"./nauru.svg": 19185,
	"./nepal.svg": 59196,
	"./netherlands-antilles.svg": 84903,
	"./netherlands.svg": 31946,
	"./new-zealand.svg": 87904,
	"./nicaragua.svg": 9423,
	"./niger.svg": 25029,
	"./nigeria.svg": 16667,
	"./niue.svg": 99715,
	"./norfolk-island.svg": 53569,
	"./north-korea.svg": 6942,
	"./northen-cyprus.svg": 81737,
	"./northern-marianas-islands.svg": 33800,
	"./norway.svg": 74280,
	"./oman.svg": 82963,
	"./orkney-islands.svg": 9917,
	"./ossetia.svg": 59374,
	"./pakistan.svg": 78547,
	"./palau.svg": 73547,
	"./palestine.svg": 5571,
	"./panama.svg": 28750,
	"./papua-new-guinea.svg": 3000,
	"./paraguay.svg": 5526,
	"./peru.svg": 93900,
	"./philippines.svg": 63243,
	"./pitcairn-islands.svg": 65251,
	"./portugal.svg": 31192,
	"./puerto-rico.svg": 77363,
	"./qatar.svg": 81045,
	"./rapa-nui.svg": 44715,
	"./republic-of-macedonia.svg": 84892,
	"./republic-of-poland.svg": 87509,
	"./republic-of-the-congo.svg": 62251,
	"./romania.svg": 89627,
	"./russia.svg": 66605,
	"./rwanda.svg": 62895,
	"./saba-island.svg": 32217,
	"./saint-kitts-and-nevis.svg": 53777,
	"./salvador.svg": 972,
	"./samoa.svg": 55659,
	"./san-marino.svg": 87457,
	"./sao-tome-and-principe.svg": 89538,
	"./sardinia.svg": 44123,
	"./saudi-arabia.svg": 52321,
	"./scotland.svg": 85266,
	"./senegal.svg": 30507,
	"./serbia.svg": 64900,
	"./seychelles.svg": 45979,
	"./sierra-leone.svg": 98176,
	"./singapore.svg": 8868,
	"./sint-eustatius.svg": 93350,
	"./sint-maarten.svg": 90527,
	"./slovakia.svg": 21986,
	"./slovenia.svg": 58103,
	"./solomon-islands.svg": 58330,
	"./somalia.svg": 25140,
	"./somaliland.svg": 26068,
	"./south-africa.svg": 89768,
	"./south-korea.svg": 53384,
	"./south-sudan.svg": 55643,
	"./spain.svg": 97525,
	"./sri-lanka.svg": 86380,
	"./st-barts.svg": 24712,
	"./st-lucia.svg": 8578,
	"./st-vincent-and-the-grenadines.svg": 31088,
	"./sudan.svg": 85039,
	"./suriname.svg": 10832,
	"./swaziland.svg": 80417,
	"./sweden.svg": 55758,
	"./switzerland.svg": 49169,
	"./syria.svg": 54974,
	"./taiwan.svg": 75858,
	"./tajikistan.svg": 57372,
	"./tanzania.svg": 84700,
	"./thailand.svg": 95747,
	"./tibet.svg": 45856,
	"./togo.svg": 45079,
	"./tokelau.svg": 24769,
	"./tonga.svg": 8461,
	"./transnistria.svg": 50290,
	"./trinidad-and-tobago.svg": 57780,
	"./tunisia.svg": 61113,
	"./turkey.svg": 69564,
	"./turkmenistan.svg": 40963,
	"./turks-and-caicos.svg": 7196,
	"./tuvalu.svg": 16297,
	"./uganda.svg": 63558,
	"./ukraine.svg": 13653,
	"./united-arab-emirates.svg": 78685,
	"./united-kingdom.svg": 42503,
	"./united-nations.svg": 68736,
	"./united-states-of-america.svg": 84283,
	"./uruguay.svg": 32554,
	"./uzbekistn.svg": 74585,
	"./vanuatu.svg": 61530,
	"./vatican-city.svg": 71030,
	"./venezuela.svg": 31523,
	"./vietnam.svg": 2422,
	"./virgin-islands.svg": 88096,
	"./wales.svg": 32350,
	"./western-sahara.svg": 94263,
	"./yemen.svg": 16724,
	"./zambia.svg": 90810,
	"./zimbabwe.svg": 27985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26558;